import { render, staticRenderFns } from "./brookline-avenue.vue?vue&type=template&id=7d90c138&"
import script from "./brookline-avenue.vue?vue&type=script&lang=js&"
export * from "./brookline-avenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports